
import React from 'react';
import { Button } from "@/components/ui/button";
import { ArrowRight, Loader } from 'lucide-react';

interface SubmitButtonProps {
  isSubmitting: boolean;
  sendText: string;
  sendingText: string;
}

const SubmitButton: React.FC<SubmitButtonProps> = ({ isSubmitting, sendText, sendingText }) => {
  return (
    <Button
      type="submit"
      disabled={isSubmitting}
      className="neo-button px-8 py-3 group"
    >
      {isSubmitting ? (
        <div className="flex items-center">
          <Loader className="w-4 h-4 mr-2 animate-spin" />
          <span>{sendingText}...</span>
        </div>
      ) : (
        <div className="flex items-center">
          <span>{sendText}</span>
          <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />
        </div>
      )}
    </Button>
  );
};

export default SubmitButton;
